import indexArray from 'index-array';
import _get from 'lodash/get';
import deepmerge from 'deepmerge';

import {
    getDataLayer,
    getConfigByBrand,
} from 'reaxl-analytics-handlers';

import { caiEvent } from '@/utils';

import { ELOT_ANALYTICS } from '@/constants/elotEvents';
import handlers from './handlers';
import eventParams from './pageParamMaps';

function buildConfigs({ brand }) {
    return {
        disableGTM: false,
        disableGTMEvents: false,
        skipPageEvent: true,
        initialConfig: getConfigByBrand(brand),
        brand,
    };
}

function buildDataLayer({ zip, pageName, pageId }) {
    return {
        page: {
            pageName,
            pg: pageId,
        },
        user: {
            zipCode: zip,
        },
    };
}

class Analytics {

    dataLayer;
    state;
    configs;
    app;
    isAnalyticsInitialized;

    constructor() {
        this.dataLayer = {};
        this.state = {};
        this.app = {};
        this.configs = {};
        this.isAnalyticsInitialized = false;
    }

    init(data) {
        const { app, brand, ...rest } = data;

        this.setDataLayer(buildDataLayer(rest));

        this.configs = { ...this.configs, ...buildConfigs({ brand }) };
        this.app = app || {};

        if (!this.isAnalyticsInitialized) { // init anaytics once
            this.listen();
            this.isAnalyticsInitialized = true
        }
    }

    listen() {
        caiEvent.listen(ELOT_ANALYTICS, this.sendTag.bind(this));
    }

    sendTag({ action, ...data }) {
        try {

            const metadata = this.getMetaData(action, data);

            // send tag!
            handlers[action](metadata, this.configs);
            caiEvent.debugLog('Analytics sent - ', action)

        } catch (error) {
            console.log(`${ELOT_ANALYTICS} ERROR: `, error);
        }
    }

    getMetaData(action, data) {

        return deepmerge({
            state: this.state,
            dataLayer: this.dataLayer,
            app: this.app,
            data: { ...eventParams?.[this.dataLayer?.page?.pg]?.[action] },
        }, data);

    }

    setDataLayer(data) {
        this.dataLayer = getDataLayer(data);
    }

    addInventory(inventory, { key = 'id' } = {}) {
        const inventoryByKey = indexArray(inventory, key);

        this.dataLayer.inventory = {
            ...this.dataLayer.inventory,
            ...inventoryByKey,
        };

        // TODO: Maybe update reaxl-analytics-handlers
        // to look up in dataLayer instead of redux
        this.state.inventory = {
            ...this.state.inventory,
            ...inventoryByKey,
        };
    }

    addOwner(owner) {
        this.dataLayer.owner = {
            ...this.dataLayer.owner,
            [owner.id]: { ...owner },
        };
    }

    setActiveOwner(id) {
        this.app.activeOwnerId = id;
    }
}

const analytics = new Analytics();

export default analytics;